export default "__VITE_ASSET__CJo0fsEc__"